// Configuration constants
export const SNAP_THRESHOLD = 4;
export const SHOW_THRESHOLD = 4;
export const SNAP_LINE_COLOR = 'rgba(255, 0, 0, 0.5)';
export const PENDING_SNAP_LINE_COLOR = 'rgba(153,0,255,0.5)';
